import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import center from '@/pages/myCenter'
import rule from '@/pages/rule'
import uploadSong from '@/pages/uploadSong'
import uploadAccompany from '@/pages/uploadAccompany'
Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    name: 'index',
    component: index,
  },
  {
    path: '/center',
    name: 'center',
    component: center
  },
  {
    path: '/center/uploadSong',
    name: 'uploadSong',
    component: uploadSong
  },
  {
    path: '/center/uploadAccompany',
    name: 'uploadAccompany',
    component: uploadAccompany
  },
  {
    path: '/rule',
    name: 'rule',
    component: rule
  }
]
export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'index',
//       component: index
//     },
//     {
//       path: '/center',
//       name: 'center',
//       component: center
//     },
//     {
//       path: '/center/uploadSong',
//       name: 'uploadSong',
//       component: uploadSong
//     },
//     {
//       path: '/center/uploadAccompany',
//       name: 'uploadAccompany',
//       component: uploadAccompany
//     }
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js